import {
  FETCH_ALL_ATTACHMENTS,
  UPDATE_ALL_ATTACHMENTS,
  UPDATE_ATTACHMENT_INPUT_SELECTION_ERROR,
  UPDATE_ATTACHMENT_UPLOAD_ERROR,
  UPDATE_ATTACHMENT_UPLOAD_PROGRESS,
  UPDATE_ATTACHMENT_UPLOAD_QUEUE,
  UPDATE_ATTACHMENT_UPLOAD_QUEUE_CURRENT_JOB_INDEX,
  UPDATE_ATTACHMENT_UPLOAD_QUEUE_TOTAL_JOBS,
  UPDATE_ATTACHMENT_WIDGET_ACTIVE,
  UPDATE_CREATE_ATTACHMENT_WITH_TIMESTAMP,
} from 'constants/actions';

export const fetchAllAttachments = (fetching = true) => {
  return { type: FETCH_ALL_ATTACHMENTS, fetching };
};

export const updateAllAttachments = (attachments = []) => {
  return { type: UPDATE_ALL_ATTACHMENTS, attachments };
};

export const updateAttachmentInputSelectionError = (err = null) => {
  return { type: UPDATE_ATTACHMENT_INPUT_SELECTION_ERROR, err };
};

export const updateAttachmentWidgetActive = (active = true) => {
  return { type: UPDATE_ATTACHMENT_WIDGET_ACTIVE, active };
};

export const updateCreateAttachmentWithTimestamp = (include = true) => {
  return { type: UPDATE_CREATE_ATTACHMENT_WITH_TIMESTAMP, include };
};

export const updateAttachmentUploadProgress = (progress = 0) => {
  return { type: UPDATE_ATTACHMENT_UPLOAD_PROGRESS, progress };
};

export const updateAttachmentUploadQueue = (attachments = []) => {
  return { type: UPDATE_ATTACHMENT_UPLOAD_QUEUE, attachments };
};

export const updateAttachmentUploadQueueCurentJobIndex = currentJobIndex => {
  return {
    type: UPDATE_ATTACHMENT_UPLOAD_QUEUE_CURRENT_JOB_INDEX,
    currentJobIndex,
  };
};

export const updateAttachmentUploadQueueTotalJobs = totalJobs => {
  return { type: UPDATE_ATTACHMENT_UPLOAD_QUEUE_TOTAL_JOBS, totalJobs };
};

export const updateAttachmentUploadError = err => {
  return { type: UPDATE_ATTACHMENT_UPLOAD_ERROR, err };
};
